/**
 * Hide Klaviyo reviews when review count is zero
 * Runs globally on all pages with product cards
 */
function hideZeroReviews() {
  const reviewElements = document.querySelectorAll('.group\\/card klaviyo-star-rating')
  reviewElements.forEach(reviewElement => {
    const observer = new MutationObserver(() => {
      const starRating = reviewElement.querySelector('.custom-star-rating')
      if (starRating) {
        const reviewText = starRating.textContent
        if (reviewText.includes('(0)')) {
          reviewElement.classList.add('hidden')
        }
        observer.disconnect()
      }
    })

    observer.observe(reviewElement, {
      childList: true,
      subtree: true
    })
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hideZeroReviews)
} else {
  hideZeroReviews()
}

document.addEventListener('product-grid:updated', hideZeroReviews)
